import { Amazon, Blockquote, VocabularyFooter } from '../../../../src/components/blog';
import { VocabularySeriesAnal } from '../../../../src/components/blog/vocabularySeries';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  VocabularyFooter,
  VocabularySeriesAnal,
  React
};